import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { Noop } from 'types/app';

import { Modal } from '@Atomic/organisms/Modal';
import Image from '@Atomic/organisms/offer/OfferLocation/CourierDeliveryBanner/img/img.png';
import { Button } from '@Atomic/atoms/Button';
import { Text } from '@Atomic/atoms/Text';

import styles from './style.module.scss';

type DeliveryAvailableModalProps = {
  visible: boolean;
  onClose: Noop;
};

export const DeliveryAvailableModal: FC<DeliveryAvailableModalProps> = ({ visible, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      bottomSheetOnMobile
      className={styles.modal}
      headerClassName={styles.modalHeader}
      containerClassName={styles.modalContainer}
      onClose={onClose}
    >
      <div className={styles.imageWrapper}>
        <div className={styles.imageContent}>
          <img src={Image} alt="" />
        </div>
      </div>

      <div className={styles.textContent}>
        <Text className={styles.title}>{t('offer.deliveryTitle')}</Text>
        <Text className={styles.description}>{t('offer.deliveryDescription')} </Text>

        <Button className={styles.button} fullWidth onClick={onClose}>
          {t('buttons.good')}
        </Button>
      </div>
    </Modal>
  );
};
